/**
 * Landing Page Copy
 */

export const landingCopy = {
  // ===========================================
  // SECTION 1: HERO
  // ===========================================
  hero: {
    headline: 'Take direct bookings on your website',
    subheadline: 'No redirects. No commissions.',
    bodyParagraph:
      'bknd lets you embed a complete booking and checkout flow directly into your site — calendar, dates, guest details, and payment included.',
    supportingLine: 'Built for independent hosts with 1–5 properties.',
    primaryCta: 'Join the waitlist',
    secondaryCta: 'See how it works',
    demoHint: 'Try it — select your dates',
  },

  // ===========================================
  // SECTION 2: HOW IT WORKS
  // ===========================================
  howItWorks: {
    sectionTitle: 'How it works',
    steps: [
      {
        title: 'Set up your property',
        description: 'Add details, pricing, and availability calendar.',
      },
      {
        title: 'Embed and test',
        description: 'Copy the widget to your site. Test bookings for free.',
      },
      {
        title: 'Go live',
        description: 'Connect Stripe when ready. Start accepting payments.',
      },
    ],
    supportingLines: ['Test mode is free and unlimited.', 'No credit card until you go live.'],
  },

  // ===========================================
  // SECTION 3: KEY BENEFITS
  // ===========================================
  keyBenefits: {
    sectionTitle: 'Key benefits',
    benefits: [
      {
        title: 'Bookings stay on your site',
        description: 'No redirects during checkout.',
      },
      {
        title: 'You own the booking',
        description: 'Not a marketplace. Not a PMS.',
      },
      {
        title: 'No commissions',
        description: 'Flat monthly pricing, per property.',
      },
      {
        title: 'Designed for no-code',
        description: 'Embed it and go live.',
      },
    ],
  },

  // ===========================================
  // SECTION 4: WHO IT'S FOR
  // ===========================================
  whoItsFor: {
    sectionTitle: "Who it's for",
    closingLine: 'Simple by design.',
    forList: {
      title: 'bknd is for you if you:',
      items: [
        'Run 1–5 short-term rental apartments',
        'Built your own website (or worked with a no-code builder)',
        'Want more direct bookings without complexity',
      ],
    },
    notForList: {
      title: 'bknd is not for:',
      items: ['Hotels', 'Large property managers', 'Complex PMS or channel-heavy setups'],
    },
  },

  // ===========================================
  // SECTION 5: FINAL CTA
  // ===========================================
  finalCta: {
    headline: 'Own your bookings.',
    supportingLine1: 'Embed the checkout.',
    supportingLine2: 'Keep the guest.',
    primaryCta: 'Join the waitlist',
    smallText: 'Early access is limited while we onboard hosts gradually.',
  },
};
